"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class DashboardClient extends authenticated_client_1.AuthenticatedClient {
    create(projectId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const _a = payload, { id, createdAt, updatedAt } = _a, body = tslib_1.__rest(_a, ["id", "createdAt", "updatedAt"]);
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards`, body);
            return response.payload;
        });
    }
    findAll(projectId, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/dashboards` + (fields ? `?fields=${fields}` : ''));
            return response.payload;
        });
    }
    getById(projectId, id, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/dashboards/${id}` + (fields ? `?fields=${fields}` : ''));
            return response.payload;
        });
    }
    update(projectId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { id, createdAt, updatedAt } = payload, body = tslib_1.__rest(payload, ["id", "createdAt", "updatedAt"]);
            const response = yield this.httpPut(`/v1/projects/${projectId}/users/me/dashboards/${id}`, body);
            return response.payload;
        });
    }
    delete(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v1/projects/${projectId}/users/me/dashboards/${id}`);
            return response.payload;
        });
    }
    markAsSeen(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`v2/projects/${projectId}/users/me/dashboards/${id}/mark-as-seen`);
            return response.payload;
        });
    }
    export(projectId, id, type, paperSize, context, selectedContexts) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const body = {
                paperSize,
                context,
                selectedContexts: selectedContexts && selectedContexts.length !== 0 ? selectedContexts : undefined,
            };
            const response = yield this.executeRaw('post', `/v1/projects/${projectId}/users/me/dashboards/${id}/export/${type}`, body);
            return {
                buffer: response.data,
                filename: DashboardClient.getFileNameFromContentDisposition(response.headers['content-disposition']),
                contentType: response.headers['content-type'],
            };
        });
    }
    share(projectId, id, message, userIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const body = { message, userIds };
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards/${id}/share`, body);
            return response.payload;
        });
    }
    undoShare(projectId, id, dashboards) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const body = { dashboards };
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards/${id}/undo-share`, body);
            return response.payload;
        });
    }
    findAllShared(projectId, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/dashboards-shared` + (fields ? `?fields=${fields}` : ''));
            return response.payload;
        });
    }
    deleteShared(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v1/projects/${projectId}/users/me/dashboards-shared/${id}`);
            return response.payload;
        });
    }
    acceptShared(projectId, dashboardIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const body = { dashboardSharedIds: dashboardIds };
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards-shared/accept`, body);
            return response.payload;
        });
    }
    undoDeleteShare(projectId, dashboardShared) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards-shared/undo-delete-share`, dashboardShared);
            return response.payload;
        });
    }
    countShared(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.findAllShared(projectId, 'id');
            return result.length;
        });
    }
    uploadCustomWidgetThumbnail(projectId, formData, progress$) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/widget/custom-thumbnail`, formData, {
                onUploadProgress: (progressEvent) => {
                    progress$.next(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                },
            });
            return response.payload;
        });
    }
    static getFileNameFromContentDisposition(contentDisposition) {
        if (!contentDisposition)
            return '';
        const match = contentDisposition.match(/filename[^;=\n]*=(?:(['"])?(.*)?\1(?:;)|[^;\n]*)/);
        if (match && match.length === 3) {
            const [_match, _quote, filename] = match;
            return filename;
        }
        return '';
    }
}
exports.DashboardClient = DashboardClient;
//# sourceMappingURL=dashboard.client.js.map